// Podiatry measurement parameter catalogue — PORTAL MIRROR.
// ⚠️ KEEP IN SYNC with backend/src/config/podiatryParams.js (single source of truth).
// The backend also returns this catalogue in GET /api/admin/podiatry/:caseId
// (`catalogue`), which the UI prefers when present; this mirror is the fallback
// and the module other components can import statically.

export const PODIATRY_PARAMS = [
  { key: 'heelWidth',              label: 'Heel width',                               unit: 'cm', autoCapable: true,  physicalOnly: false },
  { key: 'toeHeight',              label: 'Toe height',                               unit: 'cm', autoCapable: true,  physicalOnly: false },
  { key: 'heelDiagonal',           label: 'Heel diagonal',                            unit: 'cm', autoCapable: true,  physicalOnly: false },
  { key: 'limbLengthTrue',         label: 'Limb length (True)',                       unit: 'cm', autoCapable: false, physicalOnly: true  },
  { key: 'archHeightWindlass',     label: 'Arch Height - Windlass',                   unit: 'cm', autoCapable: false, physicalOnly: true  },
  { key: 'limbLengthApparent',     label: 'Limb length (Apparent)',                   unit: 'cm', autoCapable: false, physicalOnly: true  },
  { key: 'footLength',             label: 'Full length of the foot',                  unit: 'cm', autoCapable: true,  physicalOnly: false },
  { key: 'medialMalleolusHeight',  label: 'Medial malleolus height',                  unit: 'cm', autoCapable: true,  physicalOnly: false },
  { key: 'lateralMalleolusHeight', label: 'Lateral malleolus height',                 unit: 'cm', autoCapable: true,  physicalOnly: false },
  { key: 'heelTo1stMPJ',           label: 'Length of foot - Heel to 1st MPJ',         unit: 'cm', autoCapable: true,  physicalOnly: false },
  { key: 'heelTo5thMPJ',           label: 'Length of foot - Heel to 5th MPJ',         unit: 'cm', autoCapable: true,  physicalOnly: false },
  { key: 'mtpjCircumference',      label: 'MTPJ circumference - Floor to floor',      unit: 'cm', autoCapable: true,  physicalOnly: false },
  { key: 'instepCircumference',    label: 'Instep circumference - Floor to floor',    unit: 'cm', autoCapable: true,  physicalOnly: false },
  { key: 'ballWidth',              label: 'Width of the foot from the 1st - 5th MPJ', unit: 'cm', autoCapable: true,  physicalOnly: false },
]

export const PODIATRY_MODIFICATIONS = [
  'B/L Arch support',
  'B/L 4mm forefoot varus post',
  'B/L Heel cup',
  "B/L Morton's extension",
  'B/L MPJ rocker',
  'B/L Heel rocker',
  'Metatarsal pad/dome',
  'Heel raise',
  'Lateral wedge',
  'Medial wedge',
]

export const ARCH_TYPES = ['NORMAL', 'FLAT', 'HIGH']
export const MOBILITY_TYPES = ['NORMAL', 'RESTRICTED', 'HYPERMOBILE']
export const CONDITION_TAGS = ['ULCER_CALLUS', 'DEFORMITY', 'PAIN']
export const PHOTO_VIEWS = ['LATERAL', 'PLANTAR', 'DORSUM', 'MEDIAL']

export const CONDITION_LABELS = {
  ULCER_CALLUS: 'Ulcer / Callus',
  DEFORMITY: 'Deformity',
  PAIN: 'Pain',
}
